// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3E1C_","paramInput":"JobSimulator_paramInput__1wbRf","input":"JobSimulator_input__1yh6s"};